import { basicMsg } from '../../../actions/swal_msg';
import { regex_email } from '../../../constants/regex';
import { isValidGoogleMapsLocation } from '../../../helpers/admin/branch/googleMaps';

export const validateBusinessHours = (businessHours) => {
    if (!businessHours || businessHours.length <= 0) return false;

    return businessHours.every(({ dayRange, hours }) => {
        const rangeLen = dayRange.trim().length;
        const hoursLen = hours.trim().length;
        return rangeLen >= 5 && rangeLen <= 50 && hoursLen >= 5 && hoursLen <= 50;
    });
};

export const form1Validator = (values, sharedRefs, flag, setInputErr) => {
    const {
        name, phone, email, address, postalCode, colony, city,
        state, links: { whatsapp, google_maps }, file, businessHours
    } = values;
    const { number, message } = whatsapp;
    const { placeId = '', location = {} } = google_maps || {};

    const errors = {
        name_err: name.trim().length < 11 || name.trim().length > 100,
        phone_err: phone.trim().length < 5 || phone.trim().length > 15,
        email_err: email.trim().length < 5 || email.trim().length > 120 || !regex_email.test(email),
        address_err: address.trim().length < 5 || address.trim().length > 100,
        pc_err: postalCode.trim().length !== 5,
        colony_err: colony.trim().length < 5 || colony.trim().length > 100,
        city_err: city.trim().length < 3 || city.trim().length > 100,
        state_err: state.trim().length < 3 || state.trim().length > 100,
        wsp_number_err: number.trim().length < 5 || number.trim().length > 15,
        wsp_message_err: message.trim().length < 3 || message.trim().length > 200,
        place_id_err: !placeId.trim() || !isValidGoogleMapsLocation(location)
    };

    setInputErr(current => ({ ...current, ...errors }));

    const validationOrder = [
        ['name_err', 'name'], ['phone_err', 'phone'], ['email_err', 'email'],
        ['address_err', 'address'], ['pc_err', 'postalcode'], ['colony_err', 'colony'],
        ['city_err', 'city'], ['state_err', 'state'], ['wsp_number_err', 'number'],
        ['wsp_message_err', 'msg'], ['place_id_err', 'placeId']
    ];
    const invalid = validationOrder.find(([error]) => errors[error]);
    if (invalid) return focusToTextField(sharedRefs, { status: false, field: invalid[1] });

    if (flag === 'save' && !file) {
        basicMsg('Suba imagen de sucursal');
        return false;
    }
    if (!validateBusinessHours(businessHours)) {
        basicMsg('Ingrese por lo menos un horario en sucursal');
        return false;
    }
    return true;
};

const focusToTextField = (sharedRefs, { status, field }) => {
    const refs = {
        name: sharedRefs.name_ref,
        phone: sharedRefs.phone_ref,
        email: sharedRefs.email_ref,
        address: sharedRefs.address_ref,
        postalcode: sharedRefs.postalCode_ref,
        city: sharedRefs.city_ref,
        state: sharedRefs.state_ref,
        number: sharedRefs.wsp_number_ref,
        msg: sharedRefs.wsp_message_ref,
        placeId: sharedRefs.place_id_ref
    };
    const element = refs[field]?.current;
    if (element?.select) element.select();
    else element?.focus?.();
    element?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
    return status;
};
